import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Camera, Mic, UserCheck, TrendingUp } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-6 h-6 text-gold" data-id="element-171" />,
    title: 'El Manual Maestro Influencia Visual 45+ (PDF)',
    desc: 'El paso a paso para dominar tu imagen digital.'
  }, {
    icon: <Camera className="w-6 h-6 text-gold" data-id="element-172" />,
    title: "Guía de Estética 'Old Money'",
    desc: 'Cómo configurar un set de grabación profesional en tu propia casa con lo que ya tienes.'
  }, {
    icon: <Mic className="w-6 h-6 text-gold" data-id="element-173" />,
    title: 'El Guion de Hierro',
    desc: 'La estructura exacta para decir quién eres y qué haces en 60 segundos sin titubear.'
  }, {
    icon: <UserCheck className="w-6 h-6 text-gold" data-id="element-174" />,
    title: 'Protocolo de Lenguaje Corporal',
    desc: 'Técnicas para proyectar una seguridad inquebrantable frente a la cámara.'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-gold" data-id="element-175" />,
    title: 'El Algoritmo de la Madurez',
    desc: 'Cómo hacer que TikTok te muestre a compradores, no a buscadores de entretenimiento.'
  }];
  return <Section className="bg-cream-dark/30" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-serif text-center mb-16 text-navy" data-id="element-178">
          Lo que obtienes hoy:
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-179">
          {deliverables.map((item, index) => <div key={index} className="bg-white p-8 rounded-sm shadow-sm border border-gold/10 hover:border-gold/30 transition-colors duration-300 flex flex-col items-start" data-id="element-180">
              <div className="bg-cream-dark p-3 rounded-full mb-6" data-id="element-181">
                {item.icon}
              </div>
              <h3 className="text-lg font-serif text-navy mb-3" data-id="element-182">
                {item.title}
              </h3>
              <p className="text-charcoal-light font-light text-sm leading-relaxed" data-id="element-183">
                {item.desc}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}